import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';

@Component({
  selector: 'app-token-transfers',
  templateUrl: './token-transfers.component.html',
  styleUrls: ['./token-transfers.component.css']
})
export class TokenTransfersComponent implements OnInit {

  transactionList: any = {}
  trans: number = 1
  contractTransfers: any;
  tokenTransfer: any;
  abc20transactionList: any;

  constructor(private conn: ConnectionService, private router: Router,
    private alert: ToastrService) { }

  ngOnInit() {
    // this.transactionHistory();
    this.abc20Transactions('ABC20')
    this.getContractCount();
    this.getTokenCount()
  }
  transactionHistory(tokenType?: any) {
    this.conn.postUrl('wallet/getContractTrans', { type: tokenType }).subscribe((res: any) => {
      this.transactionList = res.data
    })
  }

  abc20Transactions(tokenType:any){
    this.conn.postUrl('wallet/getabc20ContractTrans', { type: tokenType }).subscribe((res: any) => {
      this.abc20transactionList = res.data
    })
  }
  // getabc20ContractTrans

  getContractCount() {
    this.conn.postUrl('users/contractTransCount', {}).subscribe((res: any) => {
      this.contractTransfers = res.data
    })
  }

  getTokenCount() {
    this.conn.postUrl('wallet/getTokenTransferCount', {}).subscribe((res: any) => {
      this.tokenTransfer = res.data
    })
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    window.scrollTo(0, 0);
    this.alert.success('Copied to the clipboard');
  }
}
